import { ISetDescriptionParams } from '~src/spacesPlatform/utils/actionParams';

import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';

export class SetProjectDescriptionRequest extends Request<ISetDescriptionParams, IEmptyResult> {
  constructor(id: string, description: string) {
    super('setProjectDescription', {
      id: id,
      description: description
    });
  }
}
